import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, getFullName, handleApiError, MasterPages, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import PaymentVoucherDrawyer from "./PaymentVoucherDrawyer";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";


export const PaymentVoucherList: React.FC<any> = React.memo((props) => {
    const { edit, view, add, remove } = getPermissions(MasterPages.Deal);
    const navigate = useNavigate();
    const [paymentListData, setPaymentlistData] = useState<any>([])
    const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();
    const params = useParams();
    const [paymentList, setPaymentVoucherList] = useState<any>();
    const { id, sid } = params;
    const dispatch = useDispatch()
    const [openF, setOpen] = React.useState(false);
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const [resetLoad, setResetLoad] = useState(false)
    const [formComponent, setFormComponent] = useState<any>()
    const { showMessage } = useSnackbar();
    const [leadData, setLeadData] = useState<any>();
    useEffect(() => {
        updateMainHeader("Payments");

        breadCrumbsStore.updateBreadCrumbs([
            { "Contacts": "/contacts/list" },
            { "Edit": `/contact/edit/${id}` },
            { "Payments": `` }
        ]);
    });

    useEffect(() => {
        const getPayments = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI('payment-voucher/lead', Method.GET, null, id);
                if (Array.isArray(response)) {
                    const updatedDeals = response.map((item: any) => ({
                        ...item,
                        leadName: getFullName(item?.lead?.firstName, item?.lead?.lastName, ''),
                    }));

                    setPaymentlistData(updatedDeals);
                }
            }
            catch (e) {
            }
        }
        getPayments();
    }, [resetLoad])
    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/deal/edit/${row?.id}`)
        } else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        }

    };
    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`payment-voucher`, Method.DELETE, null, id);
        dispatch(resetDataComponent('paymentGrid'));
        setResetLoad(true)
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()

    };

    const columns: IColumns[] = [
        // {
        //     header: "Name",
        //     fieldName: "leadName",
        // },
        // {
        //     header: "Receipt No",
        //     fieldName: "recieptNumber",
        // },
        {
            header: "Voucher No",
            fieldName: "voucherNumber",
        },
        {
            header: "Payment Date",
            fieldName: "paymentDate",
            type: "date",
        },
        {
            header: "Amount",
            fieldName: "amountReceived",
            type: "default",
        },
        {
            header: "Method",
            fieldName: "paymentMethod",
            type: "default",
        },
        {
            header: "Refference",
            fieldName: "transactionReference",
            tooltip: true,
            type: "default",
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["Delete"].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),
        },

    ];

    const handlePayment = () => {
        setOpen(true)
        const form: any =
            <PaymentVoucherDrawyer
                id="voucherDrawyer"
                control={control}
                register={register}
                reset={reset}
                setValue={setValue}
                onCancel={() => { reset(); setOpen(false) }}
            />

        setFormComponent(form)
        setTimeout(() => {
            setOpen(true)
        }, 10);
    }
    const handleVoucherData = async (data: any) => {
        try {
            dispatch(storeDataComponent('voucherSubmit', { loading: true }));
            const response: any = await saveData(data);
            if (response?.errors) {
                const mess = handleApiError(response)
                showMessage(mess, 'error');
            }
            else if (response && response?.message) {
                dispatch(resetDataComponent('paymentGrid'));
                reset()
                setResetLoad(true)
                showMessage(response.message, response.success === true ? 'success' : 'error')
            } else if (response?.id) {
                dispatch(resetDataComponent('paymentGrid'));
                setResetLoad(true)
                showMessage('Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);
            setResetLoad(false)
        }
        finally {
            dispatch(updateDataComponent('voucherSubmit', { loading: false }));
        }
    }
    const saveData = async (data: any) => {
        const request: any = {
            // "recieptNumber": data?.recieptNumber || "",
            // "voucherNumber": data?.voucherNumber || "",
            "amountReceived": data?.amountReceived || "",
            "paymentMethod": data?.paymentMethod || "",
            "transactionReference": data?.transactionReference || "",
            "narration": data?.narration || "",
            "notes": data?.notes || "",
            leadId: id,
            accountCode: "",
            invoiceNumber: "",
            payeeId: props?.notificationData?.surveyorId,
        }
        const response: any = await callAPI(`payment-voucher/MakePayment`, Method.POST, request);
        return response
    }

    return (
        <>

            {view ? <Grid container spacing={2}>
                <Grid item sm={12}>

                </Grid>
                <Grid item xs={12}>
                    <WSDataGrid
                        id="paymentGrid"
                        title="Payments"
                        columns={columns}
                        data={paymentListData}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}
                        onAddButtonClick={handlePayment}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    <SwipeableDrawerForm anchor="right" title={'Payment Voucher'}
                        openForm={openF}
                        formComponent={<form onSubmit={handleSubmit(handleVoucherData)}>
                            {formComponent}
                        </form>}
                        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}
                    />
                </Grid>
            </Grid> : <PermissionDenied />}
            <ConfirmDialog
                open={open}
                title={title}
                onConfirm={onConfirm}
                onClose={handleClose}
            />
        </>
    )
})